module.exports = __webpack_public_path__ + "static/media/usflag.3c74adad.svg";